<div class="field row" *ngIf="value != null">
    <label for="cash-paid" class="field-label" translate="cashPaidLabel"></label>
    <span id="cash-paid" class="field-data qa-cash-paid-value">{{value | localeCurrency}}</span>
</div>
